import { ArrowUp, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { waLink, WA_DEFAULT_MESSAGE } from "../config";

export const Footer = () => (
    <footer data-testid="footer" className="bg-[#03045E] text-sky-100 pb-24 md:pb-0">
        <div className="mx-auto max-w-6xl px-5 sm:px-8 py-14">
            <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
                <div className="max-w-sm">
                    <div className="flex items-center gap-3">
                        <Logo className="h-10 w-10" />
                        <span className="font-display font-bold text-white leading-tight">
                            Maria Fasanella
                            <span className="block text-[10px] font-semibold tracking-[0.2em] uppercase text-[#48CAE4]">
                                Creator Plus
                            </span>
                        </span>
                    </div>
                    <p className="mt-4 text-sm text-sky-100/70 leading-relaxed">
                        Tecnologia, Intelligenza Artificiale Performance e nuove
                        opportunità per Creator e aziende.
                    </p>
                </div>

                <nav data-testid="footer-nav" className="grid grid-cols-2 gap-x-12 gap-y-3 text-sm">
                    {[
                        ["#chi-sono", "Chi Sono"],
                        ["#attivita", "Attività"],
                        ["#progetti", "Progetti"],
                        ["#contatti", "Contatti"],
                    ].map(([href, label]) => (
                        <a
                            key={href}
                            href={href}
                            data-testid={`footer-link-${label.toLowerCase().replace(" ", "-")}`}
                            className="text-sky-100/80 hover:text-[#48CAE4] transition-colors"
                        >
                            {label}
                        </a>
                    ))}
                    <a
                        href={waLink(WA_DEFAULT_MESSAGE)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-whatsapp-link"
                        className="inline-flex items-center gap-1.5 text-sky-100/80 hover:text-[#48CAE4] transition-colors"
                    >
                        <MessageCircle className="h-4 w-4" /> WhatsApp
                    </a>
                </nav>

                <button
                    data-testid="back-to-top-button"
                    aria-label="Torna all'inizio"
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    className="self-start md:self-auto inline-flex h-12 w-12 items-center justify-center rounded-full border border-[#0077B6] text-[#48CAE4] hover:bg-[#0077B6] hover:text-white transition-colors duration-300"
                >
                    <ArrowUp className="h-5 w-5" />
                </button>
            </div>

            <div className="mt-12 pt-6 border-t border-[#0077B6]/30 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sky-100/50">
                <p>© {new Date().getFullYear()} Maria Fasanella — Creator Plus. Tutti i diritti riservati.</p>
                <p className="font-mono-tech">Tecnologia · IA Performance · Creator Economy</p>
            </div>
        </div>
    </footer>
);
